import React, { useState } from 'react';
import styles from '../InpatientPortal.module.css';
import { useDispatch, useSelector } from 'react-redux';
import inputStyles from '../../ManagementPages.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PortalFilter = ({ deviceCount = 24 }) => {
    const [searchText, setSearchText] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('Floor 2');
    const [selectedSort, setSelectedSort] = useState('Patient last name A - Z');
    
    const dispatch = useDispatch();
    
    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleFloorChange = (floor) => {
        setSelectedFloor(floor);
    };

    const handleSortChange = (sort) => {
        setSelectedSort(sort);
    };

    return (
        <div className={styles.SecondaryBar}>
            {/* Device Counter */}
            <div className={styles.DeviceCounter}>
                <p className={styles.DeviceCounterText}>
                    {deviceCount} devices connected
                </p>
            </div>

            {/* Filters */}
            <div className={styles.FiltersSection}>
                {/* Search */}
                <div style={{ display: "flex", alignItems: "center", position:"relative" }}>
                    <div style={{ position: "absolute", paddingLeft: "10px" }}>
                        <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" size="xs" style={{ color: "D9D9D9" }} />
                    </div>
                    <input
                        type="text"
                        placeholder="Search..."
                        onChange={handleSearchChange}
                        value={searchText}
                        className={inputStyles.searchInput}
                    />
                </div>

                {/* Floor Filter */}
                <div style={{ position: "relative" }}>
                        <span className="floating-label">View Floor</span>
                        <select
                            className={inputStyles["styled-input-select"]}
                            onChange={handleFloorChange}
                        >
                            <option value="name">Floor 1</option>
                            <option value="date">Floor 2</option>
                            <option value="rating">Floor 3</option>
                        </select>
                </div>

                {/* Sort Filter */}
                <div style={{ position: "relative" }}>
                    <span className="floating-label">Sort By</span>
                    <select
                        className={inputStyles["styled-input-select"]}
                        onChange={handleSortChange}
                    >
                        <option value="name">Name</option>
                        <option value="date">Date</option>
                        <option value="rating">Rating</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default PortalFilter;
